import { ForwardTradeDetailsModalProps } from "./forward-trade-details-modal.types";
import { ForwardTradeDetailsModalView } from "./forward-trade-details-modal-view";
import { useForwardTradeDetailsModal } from "./use-forward-trade-details-modal";

export const ForwardTradeDetailsModal = (props: ForwardTradeDetailsModalProps) => {
  const logic = useForwardTradeDetailsModal({ tradeContract: props.tradeContract });
  return <ForwardTradeDetailsModalView {...props} {...logic} />;
};
